import { useDispatch, useSelector } from "react-redux";

import type { BaseActivatedPanelProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import ActiveContactsRevealPanel from "app/pages/sales-intelligence/sub-modules/contacts-search/components/ContactsTableActionsPanel/ActiveContactsRevealPanel";
import { useContactsFlowStrategy } from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext";
import useActivePanelLifeCycle from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useActivePanelLifeCycle";
import {
    useContactSearchResult,
    useInvalidateContactSearchResult,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactSearchResult";
import {
    revealLeadsSearchTopNContactsWithToastThunk,
    revealMultipleContactsByIdWithToastThunk,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/effects-reveal";
import { selectMultipleRevealIsInProgress } from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import type { ContactRevealByIdRequestDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

const ContactsRevealPanelContainer = (props: BaseActivatedPanelProps) => {
    const dispatch = useDispatch();
    const contactsFlowStrategy = useContactsFlowStrategy();

    const { data, isFetching } = useContactSearchResult();
    const invalidateContacts = useInvalidateContactSearchResult();
    const isMultipleRevealInProgress = useSelector(selectMultipleRevealIsInProgress);

    useActivePanelLifeCycle();

    async function handleSubmit(topNOrIds: number | readonly ContactRevealByIdRequestDto[], onDone: () => void) {
        if (typeof topNOrIds === "number") {
            await dispatch(revealLeadsSearchTopNContactsWithToastThunk(topNOrIds));
        } else {
            await dispatch(
                revealMultipleContactsByIdWithToastThunk(topNOrIds, contactsFlowStrategy.dataSource.revealMultiple),
            );
        }

        invalidateContacts();
        onDone();
    }

    return (
        <ActiveContactsRevealPanel
            isLoading={isMultipleRevealInProgress}
            notRevealedCount={data?.totalCount || 0}
            contactsCount={data?.rows?.length || 0}
            areSearchResultsFetching={isFetching}
            onSubmit={handleSubmit}
            {...props}
        />
    );
};

export default ContactsRevealPanelContainer;
